import { axiosClient } from "services/axios";

import { AddPriceListItemParams, EditPriceListItemParams } from "../types";

export function addPriceListItem(params: AddPriceListItemParams) {
  return axiosClient.post("stores/pricelist", params);
}

export function editPriceListItem(params: EditPriceListItemParams) {
  return axiosClient.put("stores/pricelist", params);
}
